import { GridColumn } from '@grid/abstractions';
import { Filter } from '../types/filter.type';

function assignProp(
  column: GridColumn | Filter,
  prop: string,
  value: JSONValue
): void {
  Object.defineProperty(column, prop, {
    value,
    configurable: true,
    enumerable: true,
    writable: true,
  });
}

export function sortDefaultOrderValue(column: GridColumn): GridColumn {
  if (!column.filterableColumn?.order) {
    assignProp(column.filterableColumn!, 'order', 0);
  }
  return column;
}
